// src/redux/sidebar/sidebar.slice.ts

import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface SidebarState {
    collapsed: boolean;
    mobileSidebarVisible: boolean;
}

// Persist the collapsed preference so it survives reloads.
const COLLAPSED_KEY = "p3m:sidebarCollapsed";
function loadCollapsedFromStorage(): boolean {
    try {
        return localStorage.getItem(COLLAPSED_KEY) === "1";
    } catch {
        return false;
    }
}
function persistCollapsedToStorage(collapsed: boolean): void {
    try {
        localStorage.setItem(COLLAPSED_KEY, collapsed ? "1" : "0");
    } catch {
        /* ignore */
    }
}

const initialState: SidebarState = {
    collapsed: loadCollapsedFromStorage(),
    mobileSidebarVisible: false,
};

const sidebarSlice = createSlice({
    name: "sidebar",
    initialState,
    reducers: {
        toggleCollapsed: (state) => {
            state.collapsed = !state.collapsed;
            persistCollapsedToStorage(state.collapsed);
        },
        setCollapsed: (state, action: { payload: boolean; type: string }) => {
            state.collapsed = action.payload;
            persistCollapsedToStorage(state.collapsed);
        },
        toggleMobileSidebar: (state) => {
            state.mobileSidebarVisible = !state.mobileSidebarVisible;
        },
        closeMobileSidebar: (state) => {
            state.mobileSidebarVisible = false;
        },
    },
});

export const {
    toggleCollapsed,
    setCollapsed,
    toggleMobileSidebar,
    closeMobileSidebar,
} = sidebarSlice.actions;

export const selectSidebar = (state: RootState) => state.sidebar;
export default sidebarSlice.reducer;
